// Factory function to create translated stack strings
export const getStackStrings = (alias: (text: string) => string) => ({
  // Empty state messages
  NO_DEFAULT_STACK: alias('No Default Stack Found'),

  // Button labels
  CREATE_DEFAULT_STACK: alias('Create Default Stack'),
  EDIT_DEFAULT_STACK: alias('Edit Default Stack'),

  // Modal titles
  MODAL_TITLE_CREATE: alias('Create Stack'),
  MODAL_TITLE_EDIT: alias('Edit Stack'),
  MODAL_TITLE_CREATE_DEFAULT: alias('Create Default Stack'),
  MODAL_TITLE_EDIT_DEFAULT: alias('Edit Default Stack'),

  // Success messages
  SUCCESS_CREATE: alias('Stack created successfully'),
  SUCCESS_UPDATE: alias('Stack updated successfully'),
  SUCCESS_CREATE_DEFAULT: alias('Default stack created successfully'),
  SUCCESS_UPDATE_DEFAULT: alias('Default stack updated successfully'),

  // Error messages
  ERROR_DEFAULT_STACK_EXISTS: alias('Default stack already exists'),
  ERROR_CREATE_DEFAULT: alias('Failed to create default stack'),
  ERROR_UPDATE_DEFAULT: alias('Failed to update default stack'),
  ERROR_CREATE: alias('Failed to create stack'),
  ERROR_UPDATE: alias('Failed to update stack'),
});

// For backward compatibility - keep STACK_STRINGS for existing code (non-translated)
export const STACK_STRINGS = {
  // Empty state messages
  NO_DEFAULT_STACK: 'No Default Stack Found',

  // Button labels
  CREATE_DEFAULT_STACK: 'Create Default Stack',
  EDIT_DEFAULT_STACK: 'Edit Default Stack',

  // Modal titles
  MODAL_TITLE_CREATE: 'Create Stack',
  MODAL_TITLE_EDIT: 'Edit Stack',
  MODAL_TITLE_CREATE_DEFAULT: 'Create Default Stack',
  MODAL_TITLE_EDIT_DEFAULT: 'Edit Default Stack',

  // Success messages
  SUCCESS_CREATE: 'Stack created successfully',
  SUCCESS_UPDATE: 'Stack updated successfully',
  SUCCESS_CREATE_DEFAULT: 'Default stack created successfully',
  SUCCESS_UPDATE_DEFAULT: 'Default stack updated successfully',

  // Error messages
  ERROR_DEFAULT_STACK_EXISTS: 'Default stack already exists',
  ERROR_CREATE_DEFAULT: 'Failed to create default stack',
  ERROR_UPDATE_DEFAULT: 'Failed to update default stack',
  ERROR_CREATE: 'Failed to create stack',
  ERROR_UPDATE: 'Failed to update stack',
} as const;

// TypeScript type
export type StackStrings = ReturnType<typeof getStackStrings>;
